export default __webpack_public_path__ + "assets/pdf/FT_ZMag.71202d97.pdf";